import { useComposedRefs } from "../../utils/use-composed-refs.js";
import { renderElement } from "../../utils/use-render.js";
import { useTooltipContext } from "./context.js";
import { usePopupPosition } from "../popover/use-popup-position.js";
import { TooltipLabel } from "./label.js";
import { TooltipShortcut } from "./shortcut.js";
import { TooltipCSSVars } from "@videojs/core";
import { forwardRef, useCallback, useMemo, useRef } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/ui/tooltip/popup.tsx
/**
* Container for the tooltip content. Positioned relative to the trigger using CSS anchor positioning with a JavaScript
* fallback.
*/
const TooltipPopup = forwardRef(function TooltipPopup({ render, className, style, children, ...elementProps }, forwardedRef) {
	const { core, tooltip, state, preferredSide, setPositionedSide, stateAttrMap, anchorName, popupId, boundary, container } = useTooltipContext();
	const internalRef = useRef(null);
	const popupRef = useCallback((el) => {
		tooltip.setPopupElement(el);
	}, [tooltip]);
	const composedRef = useComposedRefs(forwardedRef, popupRef, internalRef);
	const posOpts = useMemo(() => ({
		side: preferredSide,
		align: state.align
	}), [preferredSide, state.align]);
	const positioningStyle = usePopupPosition({
		open: state.open,
		anchorName,
		position: posOpts,
		triggerSource: tooltip,
		popupRef: internalRef,
		boundary,
		container,
		cssVars: TooltipCSSVars,
		onSideChange: setPositionedSide
	});
	if (!state.open) return null;
	const body = children !== void 0 ? children : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(TooltipLabel, {}), /* @__PURE__ */ jsx(TooltipShortcut, {})] });
	const { onFocusOut, ...restPopupProps } = tooltip.popupProps;
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: composedRef,
		props: [
			{
				id: popupId,
				style: positioningStyle,
				...core.getPopupAttrs(state)
			},
			{ children: body },
			{
				...restPopupProps,
				onBlur: onFocusOut
			},
			elementProps
		]
	});
});
//#endregion
export { TooltipPopup };

//# sourceMappingURL=popup.js.map